<template>
    <div class="container">
        <div>
            <span>题库的题号: </span>
            <el-input
                style="margin-top: 20px; width: 90%;"
                placeholder="请输入题号"
                v-model="pbid"
                clearable>
                >
            </el-input>
        </div>
        <div>
            <span>试题的标题: </span>
        <el-input
            style="margin-top: 20px; width: 90%;"
            placeholder="请输入标题"
            v-model="title"
            clearable>
            >
        </el-input>
        </div>
        <div>
            <span>试题的题号: </span>
        <el-input
            style="margin-top: 20px; width: 90%;"
            placeholder="请输入试题题号"
            v-model="number"
            clearable>
            >
        </el-input>
        </div>
        
        <el-button type="primary" round @click="ClickMeToAdd" style="margin-left: 600px; margin-top: 20px;">提交</el-button>
        <div v-show="error_message" style="text-align: center; margin-top: 20px; font-size: 20px; font-weight: 600; color: red;">error_message: {{ error_message }}</div>
        <table class="table" style="border: 1px solid #F0F0F0; margin-top: 20px;">
            <thead>
                <tr>
                    <th scope="col" width="12%" class="header">题号</th>
                    <th scope="col" width="58%" class="header">标题</th>
                    <th scope="col" width="15%" class="header">题库题号</th>
                    <th scope="col" width="15%" class="header">我的状态</th>
                </tr>
            </thead>
            <tbody>
                <tr class="hover" v-for="item in list" :key="item.id">
                    <th class="body" scope="row">{{ item.number }}</th>
                    <td style="font-size:14px; font-weight:400; color:#25BBA6;">{{ item.title }}</td>
                    <td class="body">{{ item.pbid }}</td>
                    <td class="body">
                        <el-button type="text" @click="Delete(item.id)">删除试题</el-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
import { computeStyles } from '@popperjs/core'

    export default {
        name:'CompeteProblemTemplate',
        data() {
            return {
                pbid:'',
                title:'hh的测试题目',
                number:'A',
                error_message:'',

                list:[],
            }
        },
        mounted() {
            this.ClickMeToRead()
        },
        methods: {
            Delete(id) {
                const vue = this
                const store = this.$store
                $.ajax({
                    url: Url.dCompeteProblemUrl,
                    type:'post',
                    data: {
                        id: id
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success() {
                        vue.ClickMeToRead()
                    },
                    error(resp) {
                        console.log("删除竞赛试题彻底失败, resp == >", resp)
                    },
                })
            },
            ClickMeToRead() {
                const vue = this
                const query = this.$route.query
                // console.log(123)
                $.ajax({
                    url: Url.rCompeteProblemUrl,
                    type:'post',
                    data: {
                        competeId: query.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                            // console.log("list ==", vue.list)
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("获取竞赛试题彻底失败")
                    },
                })
            },
            ClickMeToAdd() {
                const vue = this
                const store = this.$store
                const query = this.$route.query
                console.log("id == >",query.id)
                $.ajax({
                    url: Url.cCompeteProblemUrl,
                    type:'post',
                    data: {
                        title: vue.title,
                        number: vue.number,
                        pbid: vue.pbid,
                        competeId: query.id
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success(resp) {
                        vue.error_message = resp.error_message
                        vue.ClickMeToRead()
                    },
                    error(resp) {
                        console.log("添加竞赛试题彻底失败")
                    },
                })
            }
        },
    }
</script>

<style scoped>
.body {
    text-align: center; 
    font-size:14px; 
    font-weight:400;
}
.hover:hover {
    cursor: pointer;
}
.header {
    text-align: center; 
    background-color:#EEEEEE; 
    color: #888888; 
    font-weight:500;
}
</style>